import { Injectable } from "@angular/core";
import { PublicRecordApi } from 'src/app/_shared/api/public-record.api';
import { MyListingsApi } from "../_shared/api/my-listings.api";

@Injectable({
  providedIn: 'root',
})
export class ListMyHomeService {

  constructor(
    private publicRecordApi: PublicRecordApi,
    private myListingsApi: MyListingsApi
  ) { }

  getPropertyDetails(propertyObj) {
    return this.publicRecordApi.getPropertyDetails(propertyObj);
  }

  createListing(listingObj) {
    return this.myListingsApi.createListing(listingObj);
  }

  getMyListings(params) {
    return this.myListingsApi.getMyListings(params);
  }

  getListingById(id: string) {
    return this.myListingsApi.getListingById(id);
  }

  updateListing(listingObj) {
    return this.myListingsApi.updateListing(listingObj);
  }

  deleteListing(listingObj) {
    return this.myListingsApi.deleteListing(listingObj);
  }

}